import Axios from "axios";

const baseURL = process.env.BARRAMUNDI;
const baseURLci = process.env.CI_APPS;

export default {
    getPaymentType(params) {
        return Axios.get(`${baseURL}payment/payment-type`, { params }).then(
            response => response.data.response
        );
    },
    getAdministratorBlindRefund() {
        return Axios.get(`${baseURL}payment/blind-refund-approvers`).then(
            response => response.data.response
        );
    },
    submitBlindRefundApproval(formData) {
        return Axios.post(
            `${baseURLci}billing/returns/submit_approval`,
            formData
        ).then(response => response.data);
    },
    getCreditCardPayments() {
        return Axios.get(`${baseURL}payment/credit-card-payment-type`).then(
            response => response.data.response
        );
    },
    getPaymentMethods(params) {
        return Axios.get(`${baseURL}payment/payment-method`, { params }).then(
            response => response.data.response
        );
    },
    removePayment(params) {
        return Axios.get(`${baseURLci}billing/payment/remove`, { params }).then(
            response => response.data
        );
    },
    sendSMS(formData) {
        return Axios.post(`${baseURLci}client/payment/sms`, formData).then(
            response => response.data
        );
    },
    emailReceipt(formData) {
        return Axios.post(
            `${baseURLci}client/payment/send_email`,
            formData
        ).then(response => response.data);
    },
    printReceipt(paymentId) {
        return Axios.get(`${baseURLci}billing/payment/receipt_pdf`, {
            params: { id: paymentId }
        }).then(response => response.data);
    },
    removePaymentMethod(paymentMethodId) {
        return Axios.delete(
            `${baseURL}payment/payment-method/${paymentMethodId}?entity_type=client`
        ).then(response => response.data.response);
    },
    getFundList() {
        return Axios.get(`${baseURL}payment/charitable-fund`).then(
            response => response.data.response
        );
    },
    checkInvoiceStatus(data) {
        return Axios.post(`${baseURL}payment/invoice/status`, data).then(
            response => response.data.response
        );
    },
    getPaymentIntentObject(transactionId) {
        // get Payment Intent object
        return Axios.get(
            `${baseURL}payment/stripe/payment-intent/${transactionId}`
        ).then(response => response.data.response);
    },
    getPaymentAccounts(businessId) {
        return Axios.get(`${baseURL}account/payment/processor/id`, {
            businessId
        }).then(response => response.data.response);
    },
    async getOnboardingData() {
        return await Axios.get(
            `${baseURLci}business/payment_os/retrieveToken`
        ).then(response => response.data);
    },
    saveManageKeys(formData) {
        return Axios.post(
            `${baseURLci}business/extensions/save_integrated_payment_keys`,
            formData
        ).then(response => response.data);
    },
    setAsPrimaryPaymentMethod(params) {
        return Axios.post(
            `${baseURL}payment/assign-primary-payment-method`,
            params
        ).then(response => {
            if (response && response.data && response.data.response) {
                return response.data.response;
            }
            return null;
        });
    },
    getStripeDeviceList() {
        return Axios.get(
            `${process.env.BARRAMUNDI}account/business/listDevices/STRIPE`
        ).then(res => {
            if (res && res.data.response && res.data.response.message) {
                return res.data.response.message;
            }
            return null;
        });
    },
    getCConnectDeviceList() {
        return Axios.get(`${process.env.BARRAMUNDI}payment/listDevices`).then(
            res => {
                if (res && res.data.response && res.data.response.message) {
                    return res.data.response.message;
                }
                return null;
            }
        );
    },
    saveEditDevice(params) {
        return Axios.post(`${baseURL}account/save-device`, params).then(
            response => {
                if (response && response.data && response.data.response) {
                    return response.data.response;
                }
                return null;
            }
        );
    },
    updateSaveCard(id, params) {
        //insert save card into metadata so that webhook can do checking
        return Axios.put(
            `${baseURL}payment/stripe/payment-intent/${id}`,
            params
        ).then(response => {
            if (response && response.data && response.data.response) {
                return response.data.response;
            }
            return null;
        });
    },
    getBnplPaymentType(params) {
        return Axios.post(`${baseURL}account/bnpl-payment-types`, params).then(
            response => {
                if (response && response.data && response.data.response) {
                    return response.data.response;
                }
                return null;
            }
        );
    },
    updateBnplPaymentType(id, params) {
        return Axios.put(`${baseURL}account/payment-types/${id}`, params).then(
            response => {
                if (response && response.data && response.data.response) {
                    return response.data.response;
                }
                return null;
            }
        );
    }
};
